import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet'

import { Auth, API } from 'aws-amplify';
import { getClientUser } from '../../graphql/queries'

function ShopifyCallbackMarketplace() {

  const search = useLocation().search;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loadingVisible, setLoadingVisible] = useState(true);
  const history = useHistory()
  const [ userDetails, setUserDetails ] = useState(null)
  const shop = new URLSearchParams(search).get('shop');

  useEffect(() => {
    OnLoad();
  }, []);

  function OnLoad() {
    window.location.href = 'https://'+shop+'/admin/oauth/authorize?client_id=d8a753a543933ff2a7e2ed575daf692a' +
      '&scope=read_content,read_customers,read_marketing_events,read_products&redirect_uri=https://dashboard.empushy.com/callback/shopify' +
      '&state=nonce'
  }

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Page Title */}
      <Helmet>
        <title>EmPushy | Syncing</title>
      </Helmet>

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">

        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto text-center">

            {/* Page header */}
            <div className="mb-5">
              {/* Title */}
              <h1 className="text-2xl md:text-3xl text-gray-800 font-bold">Shopify Authorisation</h1>
            </div>

          </div>
        </main>

      </div>
    </div>
  );
}

export default ShopifyCallbackMarketplace;